/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import classNames from 'classnames';

import styles from './icon.scss';
import Tooltip from '../tooltip';
import withTranslate from '../../hoc/with-translate';
import { SIDE_POSITION as POSITION } from '../../constants/positioning';

const TOOLTIP_TIMEOUT = 250;

interface Props {
  className?: string;
  iconClassName?: string;
  icon: any;
  tooltip?: string;
  placement?: POSITION;
  t: any;
}

const Icon: React.FC<Props> = ({ tooltip, icon, iconClassName, className, placement, t }) => {
  const content = <span className={classNames(iconClassName, styles.svgContainer)}>{icon}</span>;

  return tooltip ? (
    <Tooltip text={t(tooltip)} placement={placement} timeout={TOOLTIP_TIMEOUT}>
      {content}
    </Tooltip>
  ) : (
    <div className={classNames(styles.container, className)} data-hook="badge">
      {content}
    </div>
  );
};

export default withTranslate(Icon);
